import styled, { css } from 'styled-components';
import color from '../../../../../config/colors.json';
import ScreenSize from '../../../../../config/screenSizes.json';

const poppins = css`
	font-family: 'Poppins', sans-serif;
	font-style: normal;
`;

const textTitleStyle = css`
	${poppins};
	font-size: 14px;
	line-height: 20px;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const ConversionTitle = styled.em`
	${textTitleStyle};
	margin-bottom: 13px;
	text-align: center;
	display: block;
`;

export const LastDataDate = styled.span`
	${textTitleStyle};
`;

const funnelChatBaseSize = {
	desktop: '550px',
	laptop: '440px',
};

export const ConversionData = styled.div`
	margin-bottom: 15px;
	&:nth-of-type(1) {
		width: ${funnelChatBaseSize.desktop};
		background-color: ${color.lightGrey4};
		color: ${color.darkGrey};
		> div:before, > div:after {
			background-color: ${color.lightGrey4};
		}
	}
	&:nth-of-type(2) {
		width: calc(${funnelChatBaseSize.desktop} - calc(60px * 1));
		background-color: ${color.lightGrey11};
		color: ${color.darkGrey};
		> div:before, > div:after {
			background-color: ${color.lightGrey11};
		}
	}
	&:nth-of-type(3) {
		width: calc(${funnelChatBaseSize.desktop} - calc(60px * 2));
		background-color: ${color.lightGrey12};
		color: ${color.darkGrey};
		> div:before, > div:after {
			background-color: ${color.lightGrey12};
		}
	}
	&:nth-of-type(4) {
		width: calc(${funnelChatBaseSize.desktop} - calc(60px * 3));
		background-color: ${color.darkGrey6};
		color: ${color.darkGrey};
		> div:before, > div:after {
			background-color: ${color.darkGrey6};
		}
	}
	&:nth-of-type(5) {
		width: calc(${funnelChatBaseSize.desktop} - calc(60px * 4));
		background-color: ${color.redButtons};
		
		margin-bottom: 0;
		> div:before, > div:after {
			background-color: ${color.redButtons};
		}
		color: #fff;
	}
	> div {
		height: 75px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		> [role^='cell'] {
			z-index: 10;
			width: 255px;
			> em {
				${poppins};
				&:nth-child(1) {
					line-height: 37px;
					font-size: 27px;
					font-weight: 600;
					margin-right: 17px;
				}
				&:nth-child(2) {
					line-height: 23px;
					font-size: 16px;
				}
			}
		}
		&:before, &:after {
			content: '';
			width: 50px;
			height: 100%;
			position: absolute;
			top: 0;
		}
		&:before {
			left: 0;
			border-radius: 10px;
			transform:
				translateX(-50%)
				skew(20deg);
		}
		&:after {
			right: 0;
			border-radius: 10px;
			transform:
				translateX(50%)
				skew(-20deg);
		}
	}
	@media screen and (max-width: ${ScreenSize.laptop}px) {
		&:nth-of-type(1) {
			width: ${funnelChatBaseSize.laptop};
		}
		&:nth-of-type(2) {
			width: calc(${funnelChatBaseSize.laptop} - calc(60px * 1));
		}
		&:nth-of-type(3) {
			width: calc(${funnelChatBaseSize.laptop} - calc(60px * 2));
		}
		&:nth-of-type(4) {
			width: calc(${funnelChatBaseSize.laptop} - calc(60px * 3));
		}
		&:nth-of-type(5) {
			width: calc(${funnelChatBaseSize.laptop} - calc(60px * 4));
		}
		> div {
			height: 55px;
			> [role^='cell'] {
				> em {
					&:nth-child(1) {
						line-height: 37px;
						font-size: 23px;
						font-weight: 600;
						margin-right: 14px;
					}
					&:nth-child(2) {
						line-height: 23px;
						font-size: 13px;
					}
				}
			}
		}
	}
	@media screen and (max-width: ${ScreenSize.portrait}px) {
		&:nth-of-type(1) {
			width: 300px;
		}
		&:nth-of-type(2) {
			width: 250px;
		}
		&:nth-of-type(3) {
			width: 210px;
		}
		&:nth-of-type(4) {
			width: 180px;
		}
		&:nth-of-type(5) {
			width: 160px;
		}
		> div {
			height: 50px;
			> div {
				width: 160px;
				margin: 0 auto;
				position: relative;
				top: 50%;
				transform: translateY(-50%);
				> em {
					${poppins};
					&:nth-child(1) {
						line-height: 37px;
						font-size: 14px;
						font-weight: 600;
						margin-right: 5px;
						margin-left: 15px;
					}
					&:nth-child(2) {
						line-height: 23px;
						font-size: 10px;
					}
				}
			}
		}
	}
`;

export const MyConvesionTitle = styled.span`
	${poppins};
	font-size: 13px;
	line-height: 19px;
	margin: 19px 0 14px;
	`;

export const MyConversionPercentage = styled.span`
	${poppins};
	font-size: 17px;
	line-height: 24px;
	font-weight: 500;
	color: ${color.redButtons};
`;

	export const MyConversion = styled.span`
	${poppins};
	color: ${color.lightGrey13};
	font-size: 12px;
	line-height: 13px;
	text-align: center;
`;
